import { useQuery } from '@tanstack/react-query';
import { IProblematicEntity } from '../pages/path/path-pages/profile/profile-completeness/v1/profile-completeness-section';
import { apiAuthClient } from '../root/api-auth-client';

export const userProfileCompletenessQueryKey = 'user-profile-completeness';

const useUserProfileCompleteness = () => {
  const query = useQuery<
    {
      level: number;
      problematicEntities: IProblematicEntity[];
      completenessV2: 1 | 2 | 3 | 4 | 5;
    },
    Error
  >({
    queryKey: [userProfileCompletenessQueryKey],

    queryFn: async () => {
      const res = await apiAuthClient.fetch(`/api/v1/user/completeness`);
      if (!res.ok) {
        throw new Error('Network response was not ok');
      }
      return await res.json();
    },
    staleTime: 0,
  });
  return query;
};

export default useUserProfileCompleteness;
